'use client';
import { Anchor } from '@repo/ui/src/components/Anchor';
import Button from '@repo/ui/src/components/Button';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { CTAButtonProps } from '@repo/ui/src/types';
import React from 'react';

interface DealerLocatorLink {
  link?: {
    link?: string;
    externalLink?: string;
  };
}

interface Props {
  buttonProps?: CTAButtonProps;
}

const ShopLocalButton = ({ buttonProps }: Props) => {
  const { t } = useTranslation();
  const dealerLocatorLink = t<DealerLocatorLink>(
    'productDetailPageContent.dealerLocatorLink',
    undefined,
    {
      returnObjects: true,
      default: undefined,
    },
  );
  const dealerLink =
    dealerLocatorLink?.link?.link || dealerLocatorLink?.link?.externalLink || '/dealers';
  return (
    <div className="w-full">
      <Button as={Anchor} link={dealerLink} {...buttonProps}>
        {t('productDetailPageContent.locallyButtonText', undefined, {
          default: 'Shop Local',
        })}
      </Button>
    </div>
  );
};

export default ShopLocalButton;
